import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Pipe({
    name: "formGroupGet"
})
export class FormGroupGetPipe implements PipeTransform {
    public transform(formGroup: AbstractControl, controlName: string): AbstractControl | null {
        return formGroup.get(controlName);
    }
}
